import type { ReactNode } from 'react';
import React from 'react';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask';

import { i18n } from '@lt/localization';
import {
  touristFieldValidationFailedAction,
  touristFieldValidationSuccessAction,
  validateTouristFieldAction,
} from '../../routes/Checkout/store/actions/tourists';

import { formatHomoglyphsForBirthCertificate } from './utils';
import { BIRTH_CERTIFICATE_MASK } from '../../routes/Checkout/store/constants/tourists';

import type { ITouristFieldInput } from './types';

class TouristFieldInput extends React.PureComponent<ITouristFieldInput> {
  protected inputRef: ReactNode;

  constructor(props) {
    super(props);

    this.handleInput = this.handleInput.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.setRef = this.setRef.bind(this);
    this.beforeMaskedValueChange = this.beforeMaskedValueChange.bind(this);
  }

  handleInput(event) {
    const {
      pattern,
      onChange,
      preventWrongInput = false,
      onValidationFail,
      onValidationSuccess,
      idx,
      stateField,
      patternFailedMessage = `${i18n.t('checkout.touristForm.failedMessage')}`,
    } = this.props;
    const { target } = event;
    const { value } = target;

    if (pattern && value && !pattern.test(value)) {
      const error = { message: patternFailedMessage };
      onValidationFail({ field: stateField, index: idx, error });
      if (preventWrongInput) {
        return;
      }
    } else {
      onValidationSuccess({ field: stateField, index: idx });
    }
    onChange(value);
  }

  handleBlur() {
    const { formatBirthCertificate, onChange } = this.props;
    const { value } = this.props;
    if (formatBirthCertificate) {
      const trimmedValue = value?.trim();
      onChange(trimmedValue);
      if (BIRTH_CERTIFICATE_MASK.test(trimmedValue)) {
        const { formattedLatinNumbers, formattedCyrillicLetters, numbers } =
          formatHomoglyphsForBirthCertificate(trimmedValue);
        onChange(
          `${formattedLatinNumbers}-${formattedCyrillicLetters} ${numbers}`,
        );
      }
    }
    const { onBlur, stateField } = this.props;
    if (onBlur) {
      onBlur();
    }
    if (stateField) {
      const { validateTouristField, idx } = this.props;
      if (stateField && value) {
        validateTouristField({ value, field: stateField, index: idx });
      }
    }
  }

  setRef(input) {
    this.inputRef = input;
  }

  beforeMaskedValueChange(newState, oldState) {
    const { value } = newState;
    const { onChange } = this.props;

    if (oldState.value !== value) {
      onChange(value);
    }

    return newState;
  }

  render() {
    const {
      children,
      value,
      maskChar,
      placeholder,
      onFocus,
      mask = '',
      inputmode = 'text',
    } = this.props;

    return (
      <InputMask
        data-sentry-mask
        value={value}
        placeholder={placeholder}
        onFocus={onFocus}
        mask={mask}
        inputMode={inputmode}
        maskChar={value && maskChar} // do not show maskChar for empty fields
        autoComplete="fuck-off"
        onChange={this.handleInput}
        onBlur={this.handleBlur}
        inputRef={this.setRef}
        beforeMaskedValueChange={this.beforeMaskedValueChange}
      >
        {children}
      </InputMask>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  validateTouristField: (payload) =>
    dispatch(validateTouristFieldAction(payload)),
  onValidationFail: (payload) =>
    dispatch(touristFieldValidationFailedAction(payload)),
  onValidationSuccess: (payload) =>
    dispatch(touristFieldValidationSuccessAction(payload)),
});

export default connect(null, mapDispatchToProps)(TouristFieldInput);
